export const readFileAsArrayBuffer = null;
export const readFileAsText = null;
export const requireFromFile = null;
export const requireFromString = null;
//# sourceMappingURL=require-utils.browser.js.map